export default function(data) {
var __t, __p = '';
__p += '<h4 class="underlined">Your Saved Items</h4>\n<ul id="saved-items" class="reset css-grid desktop-4 tablet-4 mobile-2"></ul>\n<h4 class="underlined">Your Favorite Stores</h4>\n<ul id="saved-merchants-list" class="reset row"></ul>\n';
return __p
}